module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-5-60f96b43dc53df18ae11fc1f3d311c70.jpg";